import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { BaseModel } from '@shared/base/Base.Model';

export class KeyValuePairModel extends BaseModel implements IRestModel {

    public key: string = null;
    public readonly isIRestModel = true;
    public value: string = null;

    public constructor() {
        super();

        this.registerProperty('value');
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'EM-KeyValuePairModel');

        this.setPropertyOriginalValue('value', this.value);
    }

    public toRestApiModel() {
        throw new Error('Method not implemented.');
    }
}
